import { FunctionComponent } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import Autocomplete from '../../../../atoms/Form/Autocomplete/Autocomplete';
import { Tag } from '../../../../atoms/Tag';
import { SafeFormattedMessageWithoutSpread } from '../../../../formatters';
import { DefaultRubric } from '../../Datatable.types';
import { DatatableFiltersModel } from '../DatatableFiltersModel';
import messages from '../messages';

import { useFilterDefault } from './FiltersDefault.hooks';

const FiltersDefault: FunctionComponent<{
  filter: DefaultRubric;
  onChange: (selectedFilter: DefaultRubric) => void;
  dataTestId?: string;
}> = ({ filter, onChange, dataTestId }) => {
  const { filtersValue, buildFiltersOptions, handleFilterSelected } =
    useFilterDefault({ filter, onChange, dataTestId });

  const { control } = useFormContext();

  return (
    <DatatableFiltersModel
      title={filter.label}
      tag={
        <Tag
          primary
          withoutMargin
          dataTestId={`${dataTestId}_filterDefault_tag_${filter.name}`}
        >
          {filtersValue.length ===
          Object.values(buildFiltersOptions(filter.facets)).length ? (
            <SafeFormattedMessageWithoutSpread message={messages.allSelected} />
          ) : (
            filtersValue.length
          )}
        </Tag>
      }
      filterContent={
        <Controller
          name={`filterDefault_${filter.name}`}
          control={control}
          render={({ field }) => (
            <Autocomplete
              ref={field.ref}
              value={field.value}
              name={field.name}
              closeMenuOnSelect={false}
              isLoading={false}
              isMulti
              onChange={(newValue) => {
                field.onChange(newValue);
                handleFilterSelected(newValue as any);
              }}
              options={buildFiltersOptions(filter.facets)}
              placeholder={messages.selectFilters}
              dataTestId={`${dataTestId}_filterDefault_${filter.name}`}
            />
          )}
        />
      }
    />
  );
};

FiltersDefault.displayName = 'FiltersDefault';
export default FiltersDefault;
